<template>
	<article class="theme-register-page">
		<page-header />
		<theme-controller ref="theme" @submit="register" />
		<div class="btn-wrap-main">
			<button
				type="button"
				class="btn-main"
				v-text="'미리보기'"
				@click="preview"
			/>
			<button
				form="theme"
				type="submit"
				class="btn-main blue"
				v-text="'등록'"
			/>
		</div>
	</article>
</template>
<script>
	import PageHeader from '@/components/PageHeader.vue';
	import ThemeController from '@/components/operation/ThemeController.vue';

	export default {
		name: 'ThemeRegister',
		components: { PageHeader, ThemeController },
		data() {
			return {
				isSuccessBack: false,
			};
		},
		async beforeRouteLeave(to, from, next) {
			if (!this.isSuccessBack) {
				next();
			} else if (to.name === 'ThemeList') {
				next();
			} else {
				next({ name: 'ThemeList' });
			}
		},
		methods: {
			preview() {
				this.$refs.theme.preview();
			},
			async register() {
				const registerSuccess = await this.$refs.theme.register();
				if (!registerSuccess) return;
				this.isSuccessBack = true;
				this.$router.go(-1);
			},
		},
	};
</script>
